function mapStationNetwork(n) {
    const tokens = n.tokens.map(t => ({
        symbol: t.symbol,
        contractAddress: t.contract,
        decimals: t.decimals,
        logo: t.logoUrl,
    }));
    return {
        caip2Id: n.caip2Id,
        displayName: n.displayName,
        chainId: n.chainId,
        nativeTokenAddress: n.nativeTokenAddress,
        type: { name: n.networkType },
        tokens,
        nodes: [],
        contracts: [],
        metadata: [],
        explorerUrlTemplate: n.explorerUrlTemplate,
        logoUrl: n.logoUrl,
    };
}
export class TrainApiError extends Error {
    constructor(message, status) {
        super(message);
        this.status = status;
        this.name = 'TrainApiError';
    }
}
export class TrainApiClient {
    constructor(config) {
        if (!config.baseUrl) {
            throw new Error('TrainApiClient: baseUrl is required. Set NEXT_PUBLIC_TRAIN_API env var.');
        }
        this.baseUrl = config.baseUrl.replace(/\/$/, '');
    }
    async getNetworks() {
        const data = await this.request('GET', '/networks');
        return (data.data ?? []).map(mapStationNetwork);
    }
    async getPrices() {
        const data = await this.request('GET', '/prices');
        return data.data ?? {};
    }
    async getSwaps(addresses, page = 1) {
        const query = addresses.map(a => `addresses=${encodeURIComponent(a)}`).join('&');
        const data = await this.request('GET', `/swaps?${query}&page=${page}`);
        return data.data ?? [];
    }
    async getOrder(solverId, hashlock) {
        const data = await this.request('GET', `/orders/${solverId}/${hashlock}`);
        return data.data;
    }
    async revealSecret(solverId, hashlock, secret) {
        const params = { secret };
        await this.request('POST', `/orders/${solverId}/${hashlock}/reveal-secret`, params);
    }
    async getQuote(params) {
        const { includeReward = true, sourceTokenContract, destinationTokenContract, ...rest } = params;
        const urlParams = new URLSearchParams({
            ...rest,
            includeReward: String(includeReward),
        });
        if (sourceTokenContract)
            urlParams.set('sourceTokenContract', sourceTokenContract);
        if (destinationTokenContract)
            urlParams.set('destinationTokenContract', destinationTokenContract);
        const query = urlParams.toString();
        const data = await this.request('GET', `/quote?${query}`);
        return data.data;
    }
    async request(method, path, body) {
        const url = `${this.baseUrl}/api/v1${path}`;
        const res = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
        });
        if (!res.ok) {
            const text = await res.text().catch(() => res.statusText);
            throw new TrainApiError(`${method} ${path} failed (${res.status}): ${text}`, res.status);
        }
        return res.json();
    }
}
